import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-table',
  templateUrl: './empty-table.component.html',
  styleUrls: ['./empty-table.component.scss']
})
export class EmptyTableComponent implements OnInit {
  @Input() message: string;
  @Input() title: string;
  @Input() noBorder: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
